export const GET_AFFILIATE = "GET_AFFILIATE";
export const GET_AFFILIATE_FAILURE = "GET_AFFILIATE_FAILURE";
export const GET_AFFILIATE_SUCCESS = "GET_AFFILIATE_SUCCESS";

export const UPDATE_AFFILIATE = "UPDATE_AFFILIATE";
export const UPDATE_AFFILIATE_FAILURE = "UPDATE_AFFILIATE_FAILURE";
export const UPDATE_AFFILIATE_SUCCESS = "UPDATE_AFFILIATE_SUCCESS";

export const ADD_COUPON = "ADD_COUPON";
export const ADD_COUPON_FAILURE = "ADD_COUPON_FAILURE";
export const ADD_COUPON_SUCCESS = "ADD_COUPON_SUCCESS";